import React from 'react';
import Head from 'next/head';

import { Container } from '../../components';
import PanelBenefits from '../../components/careers/PanelBenefits';
import PanelJoin from '../../components/careers/PanelJoin';
import PanelMission from '../../components/careers/PanelMission/PanelMission';
import PanelValues from '../../components/careers/PanelValues';
import { setPageTitle } from '../../utils/base';

export default function Careers() {
  return (
    <>
      <Head>
        <title>{setPageTitle('Careers')}</title>
      </Head>
      <Container fullWidth>
        <PanelMission />
        <PanelValues />
        <PanelBenefits />
        <PanelJoin />
      </Container>
    </>
  );
}
